import styled from "styled-components";
import { motion } from "framer-motion";

export const Bar = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  z-index: 10000000;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.accent},
    ${({ theme }) => theme.accentDark}
  );
  box-shadow: 0px 0px 5px black;
  transform-origin: center;
`;
